import React from 'react';
import { Comment, ReplyComment, CommentStatuses } from '../comment-types';
import { Chip, Typography } from '@mui/material';

type CommentStatusProps = {
  comment: Comment | ReplyComment;
};
export const CommentSearchStatus: React.FC<CommentStatusProps> = ({
  comment,
}) => {
  let color: string;
  let label;

  switch (comment.status) {
    case CommentStatuses.APPROVED:
      color = '#2e7d32';
      label = 'APROBADO';
      break;
    case CommentStatuses.REJECTED:
      color = '#FF0000';
      label = 'RECHAZADO';
      break;
    default:
      color = 'warning';
      label = 'PENDIENTE';
  }

  return (
    <Typography fontSize={16} color={color} fontWeight={700}>
      <span
        style={{ color, fontSize: '20px', lineHeight: '16px', paddingRight: 4 }}
      >
        &bull;
      </span>
      {label}
    </Typography>
  );
};
